<div class="app-wrapper">
  <div [class.blurred]="showWarning()">
    <router-outlet></router-outlet>
  </div>

  @if (showWarning()) {
    <div class="warning-overlay">
      <div class="warning-popup">
        <p class="warning-message">
          Bienvenu sur le site mettant à disposition les statistiques de la these sur les prescriptions de psychotropes pour les patients en EHPAD 34 en Haute-Vienne
        </p>
        <div class="warning-second-block">
          <span class="warning-icons">
            <span class="warning-icon">&#9888;</span>
            <span class="warning-icon warning-icon--medical">&#9877;</span>
          </span>
          <p class="warning-message">
            Cette application contient des données médicale, pour confirmer que vous faites partie du personnel soignant, veuillez indiquer le nom de famille de l'auteur de la these.
          </p>
        </div>
        <div class="warning-input-group">
          <input
            type="text"
            class="warning-input"
            [class.error]="codeError()"
            placeholder="Entrez le nom"
            [value]="codeInput()"
            (input)="onCodeInput($any($event.target).value)"
            (keydown)="onKeydown($event)"
            autofocus
          />
          @if (codeError()) {
            <span class="warning-error">Nom invalide, veuillez réessayer.</span>
          }
        </div>
        <button class="warning-btn" (click)="submitCode()">Confirmer</button>
      </div>
    </div>
  }
</div>
